<template>
  <div class='row-libray'>
    <LeftListSupplier :pos="5"></LeftListSupplier>
    <div class="g-row2">
      <div class="m-hone1 m-libray">
        <div class="top">
          <div class="tit">按ISBN编码查询：</div>
          <a-input-search class="m-so" placeholder="请输入ISBN编码" @search="onSearch" />
        </div>

        <div class="contect">
          <div class="top1">
            <div class="tit2">图书列表</div>
            <div class="con2">
              <div class="btn1" @click="showModal">批量添加</div>
              <div class="btn1 btn2">批量删除</div>
            </div>
          </div>

          <div class="m-table">

            <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :columns="columns"
              :data-source="data" :pagination="false" :bordered="false"
              :scroll="{ x: 700 }">
              <div slot="delete" slot-scope="index, record, indent, expanded" class="delete" style="color: #188EFC;">
                <span >删除</span>
              </div>
              <div slot="customTitle"><span class="td1 on" :class="{ active1: isActive1 }"
                  @click="toggleActive1">出版日期<img src="@/assets/images/e-load2.png" class="icon" alt="" /><img
                    src="@/assets/images/e-load2-on.png" class="icon icon2" alt="" /></span></div>


              <!-- <div slot="datepublication" slot-scope="publication, record, indent, expanded" class="publication" >
                <span>出版日期</span> <img src="@/assets/images/e-load3.png" class="img" alt="" />
              </div> -->
              <div slot="fixprice"><span class="td1" :class="{ active2: isActive2 }" @click="toggleActive2">定价<img
                    src="@/assets/images/e-load1.png" class="icon" alt="" /><img src="@/assets/images/e-load1-on.png"
                    class="icon icon2" alt="" /></span></div>
              <div slot="discount"><span class="td1 td2 " :class="{ active: isActive }" @click="toggleActive">折扣<img
                    src="@/assets/images/e-icon4.png" class="icon" alt="" /><img src="@/assets/images/e-icon4-on.png"
                    class="icon icon2" alt="" /></span></div>
              <!-- <div slot="discount" slot-scope="index, record, indent, expanded" class="discount"
                style="color: #3871E9;">
                <span>折扣</span>
              </div> -->

            </a-table>
          </div>
          <mPages />
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <a-modal :visible="visible" @ok="handleOk" class="m-pope1" @cancel="handleCancel" :footer="null" :centered="true"
      :closable="false" :width="895">
      <div class="inner">
        <div class="tit">导入目录</div>
        <div class="info">导入.xlsx文件（Excel表格，每行一条书目）</div>
        <a-upload name="file" :multiple="true" action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          :headers="headers" @change="handleChange">
          <a-button>点击请选择需要导入的文件.xls</a-button>
        </a-upload>
        <button class="btn" @click="() => (visible = false)">确认提交</button>
        <!-- <div class="info1">注：提交后目录列表状态显示为已上传</div> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
import LeftListSupplier from "@/components/LeftListSupplier";
import mPages from '@/components/mpages/mPages.vue'
export default {
  components: {
    LeftListSupplier,
    mPages,
  },
  computed: {
    container() {
      return bus.container;
    }
  },
  data() {
    return {
      //
      isActive1: false,
      isActive2: false,
      isActive: false,
      //
      ModalText: "Content of the modal",
      visible: false,
      confirmLoading: false,

      // 表单
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: '',
        name2: '',
        name3: '',
        name4: '',
        region: undefined,
        region2: undefined,
      },
      // 表格
      selectedRowKeys: [], // Check here to configure the default column
      columns: [
        {
          title: "ISBN",
          dataIndex: "order",
          key: "order",
          width: '9.5%',

        },
        {
          title: "书名",
          dataIndex: "value1",
          key: "value1",
          width: '14.2%',
          ellipsis: true,
        },
        {
          title: "出版社",
          dataIndex: "value2",
          key: "value2",
          width: '9.5%',
          ellipsis: true,
        },
        {
          title: "作者",
          dataIndex: "value3",
          key: "value3",
          ellipsis: true,
          width: '4.4%',
        },

        {
          title: "发行时间",
          dataIndex: "value4",
          key: "value4",
          ellipsis: true,
          width: '7.4%',
          slots: { title: 'customTitle' },
          scopedSlots: { customRender: '发行时间' },
        },

        {
          title: "发行时间",
          dataIndex: "value5",
          key: "value5",
          ellipsis: true,
          width: '6.8%',
        },
        {
          title: "印张",
          dataIndex: "value6",
          key: "value6",
          ellipsis: true,
          width: '3.4%',
        },
        {
          // title: "定价",
          dataIndex: "value7",
          key: "value7",
          ellipsis: true,
          width: '6.1%',
          // sorter: true,
          // scopedSlots: { customRender: 'name' },
          slots: { title: 'fixprice' },
          scopedSlots: { customRender: '定价' },
        },
        {
          // title: "折扣",
          dataIndex: "value8",
          key: "value8",
          ellipsis: true,
          width: '8.4%',
          slots: { title: 'discount' },
          scopedSlots: { customRender: '折扣' },
        },
        {
          title: "分类",
          dataIndex: "value9",
          key: "value9",
          ellipsis: true,
          width: '6.1%',
        },
        {
          title: "读者",
          dataIndex: "value10",
          key: "value10",
          ellipsis: true,
          width: '6.1%',
        },
        {
          title: "操作",
          dataIndex: "value11",
          key: "value11",
          ellipsis: true,
          width: '9.5%',
          scopedSlots: { customRender: 'delete' },
        },

      ],
      data: [
        {
          key: "1",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "2",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "3",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "4",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "5",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "6",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "7",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "8",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "9",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "10",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "11",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "12",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "13",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "14",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "15",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "16",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "17",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "18",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "19",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
        {
          key: "20",
          order: "9787569941920",
          value1: "python编程从入门到精通",
          value2: "北京时代华文书局",
          value3: "王博文",
          value4: "2023/8/1",
          value5: "2023/8/1",
          value6: "476",
          value7: "48",
          value8: "22",
          value9: "A",
          value10: "中学",
          value11: "删除",
        },
      ],


    };
  }, computed: {},
  mounted() { },
  methods: {
   // 类名
   toggleActive1() {
      this.isActive1 = !this.isActive1;
    },
    toggleActive2() {
      this.isActive2 = !this.isActive2;
    },
    toggleActive() {
      this.isActive = !this.isActive;
    },
    // 类名end
    showModal() {
      this.visible = true;
    },
    handleCancel(e) {
      this.visible = false;
    },
    // 表格
    // 搜索
    onSearch(value) {
      console.log(value);
    },
    onSubmit() {
      console.log('submit!', this.form);
    },
    // 表格
    onSelectChange(selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },

  },
};

</script>

<style lang="scss" scoped>
.ant-input-affix-wrapper .ant-input-suffix {
  right: 0;
}
</style>
